import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';
import { WhyNotBuying } from '@/components/tools/why-not-buying';
export default function WhyNotBuyingPage() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><title>Why Aren't People Buying Your Product? | Sizzle</title><meta name="description" content="Work out why people aren't buying your product and get concrete ideas to change that. A simple self-assessment for CPG and food & beverage brands." /></Head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-amber-500/20 blur-3xl" />;
    t2 = <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-orange-600/20 blur-3xl" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <nav className="mb-8 flex items-center gap-1.5 text-sm text-gray-400"><Link href="/tools" className="cursor-pointer transition-colors hover:text-white">Tools</Link><ChevronRight className="h-3.5 w-3.5" /><span className="font-medium text-white">Why Aren't People Buying Your Product?</span></nav>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="relative overflow-hidden border-b border-gray-200 bg-gray-950 text-white">{t1}{t2}<div className="relative mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-16 lg:px-8">{t3}<div className="max-w-3xl"><h1 className="mt-5 text-4xl font-black leading-[1.05] tracking-tight sm:text-6xl">Why aren't people buying your product, how to change that</h1><p className="mt-5 max-w-2xl text-base leading-relaxed text-gray-300 sm:text-lg">People don't buy your product for three broad reasons: they don't know about it, they know but haven't considered buying it, or there's no particular reason not to buy — they just aren't. Where are your consumers at?</p></div></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <>{t0}<main className="min-h-screen bg-white">{t4}<section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14 lg:px-8"><WhyNotBuying /></section></main></>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}